export const hr = {
  common: {
    save: "Spremi",
    cancel: "Odustani",
    close: "Zatvori",
    delete: "Obriši",
    edit: "Uredi",
    create: "Kreiraj",
    update: "Ažuriraj",
    loading: "Učitavanje",
    error: "Greška",
    saved: "Spremljeno",
    yes: "Da",
    no: "Ne",
    all: "Sve",
    apply: "Primijeni",
    signOut: "Odjavi se",
    confirm: "Potvrdi",
    optionalNotes: "Opcionalne bilješke",
    confirmDelete: "Potvrdi brisanje",
    current: "Trenutno",
    ok: "OK",
    warning: "Upozorenje",
    success: "Uspješno",
    back: "Nazad",
    copied: "Kopirano",
    refresh: "Osvježi",
    add: "Dodaj",
    change: "Promijeni",
    countryCode: "Pozivni broj",
    none: "Nema",
  },

  auth: {
    login: "Prijava",
    logout: "Odjava",
    register: "Registracija",
    email: "Email",
    phone: "Telefon",
    password: "Lozinka",
    confirmPassword: "Potvrdi lozinku",
    firstName: "Ime",
    lastName: "Prezime",
    accountName: "Naziv računa",
    loginFailed: "Prijava nije uspjela.",
    signInSubtitle: "Upravljajte apartmanima, rezervacijama i gostima.",
    forgotPassword: "Zaboravili ste lozinku?",
    forgotPasswordSubtitle:
      "Unesite email i poslat ćemo vam upute za resetiranje lozinke.",
    sendResetLink: "Pošalji link za resetiranje",
    backToLogin: "Nazad na prijavu",
    or: "ili",
    loginWithGoogle: "Nastavi s Googleom",
    loginWithFacebook: "Nastavi s Facebookom",
    noAccount: "Nemate račun?",
    createAccount: "Kreiraj račun",
    alreadyHaveAccount: "Već imate račun?",
    registerSubtitle:
      "Kreirajte RentPilot račun i počnite upravljati smještajem.",
    verifyEmailBanner:
      "Molimo potvrdite svoju email adresu prije korištenja svih RentPilot funkcija.",
    resendVerificationEmail: "Pošalji ponovno",
    iVerified: "Potvrdio sam",
    resetPassword: "Reset password",
    resetPasswordSubtitle: "Enter a new password for your RentPilot account.",
    newPassword: "New password",
    invalidResetLink: "The password reset link is invalid or incomplete.",
  },

  tabs: {
    calendar: "Kalendar",
    properties: "Objekti",
    statistics: "Statistika",
    profile: "Profil",
    team: "Tim",
    cleaners: "Tim",
    support: "Podrška",
    cleaningTasks: "Zadaci",
    invoices: "Računi",
    menu: "Meni",
  },

  cleaners: {
    title: "Tim",
    add: "Dodaj",
    cleaners: "Članovi tima",
    newCleaner: "Novi član tima",
    createCleaner: "Kreiraj člana tima",
    noCleaners: "Još nema članova tima.",
    schedule: "Raspored",
    noTasks: "Nema zadataka čišćenja.",
    assignCleaner: "Dodijeli člana tima",
    cleanedHistory: "Povijest čišćenja",
    noCleanedHistory: "Još nema očišćenih jedinica.",
    failedCreateCleaner: "Nije moguće kreirati člana tima.",
    deleteQuestion: "Obrisati {{name}}?",
    description: "Upravljajte članovima tima i njihovim pristupom aplikaciji.",
    teamAccess: "Pristup timu",
    members: "članova",
    addMemberDescription:
      "Dodajte menadžera, promatrača ili čistačicu u svoj račun.",
    roleOverview: "Pregled uloga",
    managerDescription:
      "Može upravljati rezervacijama, objektima, gostima, zadacima i timom.",
    viewerDescription: "Može pregledavati kalendar bez upravljanja podacima.",
    cleanerDescription: "Vidi samo zadatke koji su dodijeljeni za čišćenje.",
  },

  cleaning: {
    myTasks: "Moji zadaci",
    today: "Danas",
    upcoming: "Nadolazeće",
    done: "Gotovo",
    noTasksToday: "Nema zadataka za danas.",
    noUpcomingTasks: "Nema nadolazećih zadataka.",
    noDoneTasks: "Nema završenih zadataka.",
    scheduled: "Zakazano",
    cleanedAt: "Očišćeno u",
    assignedTo: "Dodijeljeno",
    unassigned: "Nije dodijeljeno",
    start: "Počni",
    markCleaned: "Označi kao očišćeno",
    futureTaskCannotBeCompleted:
      "Ovaj zadatak može biti završen na zakazani dan.",
    status: {
      pending: "Na čekanju",
      in_progress: "U toku",
      done: "Gotovo",
      cancelled: "Otkazano",
    },
    description:
      "Pregled današnjih zadataka, nadolazećih čišćenja i povijesti završenih čišćenja.",
  },

  calendar: {
    unit: "Jedinica",
    noUnits: "Nema jedinica",
    filters: "Filteri",
    startDate: "Početni datum",
    endDate: "Završni datum",
    thisWeek: "Ovaj tjedan",
    twoWeeks: "Dva tjedna",
    threeWeeks: "Tri tjedna",
    thisMonth: "Ovaj mjesec",
    occupied: "Zauzeto",
    unavailable: "Nedostupno",
    rangeOverlaps:
      "Odabrani raspon datuma preklapa se s postojećom rezervacijom.",
    occupiedCellMessage: "Ova jedinica već ima rezervaciju na odabrani datum.",
    selectCheckIn: "Odaberi check-in",
    selectCheckOut: "Odaberi check-out",
    clear: "Očisti",
    multi: "Više",
    single: "Jedan",
    next7Days: "Sljedećih 7 dana",
    next14Days: "Sljedećih 14 dana",
    selectedStart: "Odabrani početak",
    tapCheckoutDate: "Dodirnite datum check-outa za kreiranje rezervacije",
    subtitle:
      "Pregled jedinica, rezervacija, plaćanja i boravaka koji pokreću čišćenje.",
    available: "Slobodno",
    addObjects: "Dodaj objekte",
    addObjectsDescription:
      "Kreiraj prvi objekat i jedinicu da započneš upravljanje rezervacijama.",
    month: "Mjesec",
    next: "Dalje",
    allUnits: "Svi apartmani",
    checkInAfter: "Ulaz od 14:00",
    checkOutBefore: "Izlaz do 10:00",
    cleaning: "Čišćenje",
    private: "Privatno",
    closed: "Zatvoreno",
    today: "Danas",
    fullYear: "Cijela godina",
    availableDates: "Slobodni termini",
    availableDatesByUnit: "Slobodni termini po apartmanima",
    shown: "prikazano",
    terms: "termina",
    noFreePeriods: "Nema slobodnih termina",
  },

  booking: {
    newBooking: "Nova rezervacija",
    bookingDetails: "Detalji rezervacije",
    guestFirstName: "Ime gosta",
    guestLastName: "Prezime gosta",
    guest: "Gost",
    phone: "Telefon",
    email: "Email",
    unit: "Jedinica",
    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "Noćenja",
    pricePerNight: "Cijena po noći",
    total: "Ukupno",
    status: "Status",
    payment: "Plaćanje",
    paymentStatus: "Status plaćanja",
    unpaid: "Neplaćeno",
    deposit: "Depozit",
    paid: "Plaćeno",
    reserved: "Rezervirano",
    checkedIn: "Prijavljen",
    checkedOut: "Odjavljen",
    cancelled: "Otkazano",
    notes: "Bilješke",
    createBooking: "Kreiraj rezervaciju",
    failedCreate: "Nije moguće kreirati rezervaciju.",
    guestFirstNamePlaceholder: "Ivan",
    guestLastNamePlaceholder: "Horvat",
    phonePlaceholder: "+387...",
    emailPlaceholder: "ivan@example.com",
    pricePlaceholder: "45",
    arrivingAround: "Dolazak oko 18:00",
    currency: "Valuta",
    dateRange: "Datumi boravka",
    selectDates: "Odaberi datume",
    selectCheckIn: "Odaberi datum check-ina",
    selectedDateOccupied: "Ovaj datum je već zauzet.",
    selectedRangeOverlaps:
      "Odabrani datumi preklapaju se s postojećom rezervacijom.",
    numberOfGuests: "Broj gostiju",
    checkoutAfterCheckin: "Check-out mora biti nakon check-in datuma.",
    contactGuest: "Kontaktiraj gosta",
    invoice: "Račun",
    whatsapp: "WhatsApp",
    missingEmail: "Ovaj gost nema email adresu.",
    missingPhone: "Ovaj gost nema broj telefona.",
    noContactInfo: "Ovaj gost nema email adresu ni broj telefona.",
    confirmSendInvoice: "Poslati račun ovom gostu?",
    invoiceSent: "Račun je poslan.",
    failedSendInvoice: "Slanje računa nije uspjelo.",
    booking: "Rezervacija",
    editBooking: "Uredi rezervaciju",
    saveBooking: "Sačuvaj rezervaciju",
    sendInvoice: "Pošalji fakturu",
    cancelBooking: "Otkaži rezervaciju",
    cancelBookingQuestion:
      "Da li ste sigurni da želite otkazati ovu rezervaciju?",
    bookingCreated: "Rezervacija je kreirana.",
    bookingUpdated: "Rezervacija je ažurirana.",
    bookingCancelled: "Rezervacija je otkazana.",
    failedUpdate: "Ažuriranje rezervacije nije uspjelo.",
    failedCancel: "Otkazivanje rezervacije nije uspjelo.",
    unitMissing: "Jedinica nedostaje.",
    emailUnavailable: "Email nije dostupan.",
    emailSubject: "Informacije o rezervaciji",
    emailBody: "Pozdrav, ovo su detalji vaše rezervacije.",
    whatsappMessage: "Pozdrav, ovo su detalji vaše rezervacije.",
    missingGuestEmail: "Email gosta nedostaje.",
    confirmSendInvoiceMessage: "Faktura će biti poslana na email adresu gosta.",
    checked_in: "Prijavljen",
    checked_out: "Odjavljen",
  },

  bookingMessages: {
    title: "WhatsApp poruka",
    templateOne:
      "Pozdrav {{guest}}, vaša rezervacija za {{unit}} je potvrđena od {{checkIn}} do {{checkOut}}.",
    templateTwo:
      "Pozdrav {{guest}}, hvala na rezervaciji. Check-in je {{checkIn}}, a check-out {{checkOut}}.",
    templateThree:
      "Pozdrav {{guest}}, veselimo se vašem dolasku u {{unit}}. Vaši datumi su {{checkIn}} - {{checkOut}}.",
    templateButton: "Predložak {{number}}",
    customPlaceholder: "Napišite poruku...",
    openWhatsApp: "Otvori WhatsApp",
    customMessage: "Prilagođena poruka",
    invalidPhone: "Neispravan broj telefona.",
    missingPhone: "Broj telefona nedostaje.",
    whatsappUnavailable: "WhatsApp nije dostupan.",
  },

  properties: {
    title: "Objekti",
    newProperty: "Novi objekt",
    createProperty: "Kreiraj objekt",
    propertyName: "Naziv objekta",
    address: "Adresa",
    city: "Grad",
    notes: "Bilješke",
    noUnits: "Još nema jedinica",
    units: "jedinica",
    newUnit: "Nova jedinica",
    createUnit: "Kreiraj jedinicu",
    unitName: "Naziv jedinice",
    type: "Tip",
    capacity: "Kapacitet",
    defaultPricePerNight: "Zadana cijena po noći",
    noDefaultPrice: "Nema zadane cijene",
    guests: "gosti",
    disable: "Onemogući",
    enable: "Omogući",
    deleteProperty: "Obriši objekt",
    deletePropertyQuestion:
      "Obrisati {{name}}? Ovo radi samo ako nema povijesti rezervacija.",
    deleteUnit: "Obriši jedinicu",
    deleteUnitQuestion:
      "Obrisati ovu jedinicu? Ako ima povijest rezervacija, možete je deaktivirati.",
    failedCreateProperty: "Nije moguće kreirati objekt.",
    failedCreateUnit: "Nije moguće kreirati jedinicu.",
    apartment: "Apartman",
    room: "Soba",
    studio: "Studio",
    house: "Kuća",
    other: "Ostalo",
    newPropertyPlaceholder: "Sarajevo Apartments",
    addressPlaceholder: "Ulica 1",
    cityPlaceholder: "Sarajevo",
    notesPlaceholder: "Opcionalne bilješke",
    unitNamePlaceholder: "Apartman A",
    pricePlaceholder: "45",
    capacityPlaceholder: "2",
    pricePerNightShort: "{{price}} / noć",
    deletePropertySuccess: "Objekt obrisan.",
    deleteUnitSuccess: "Jedinica obrisana.",
    addUnit: "Dodaj jedinicu",
    activeUnits: "aktivne jedinice",
    inactiveUnits: "neaktivne jedinice",
    calendarSync: "Sinkronizacija kalendara",
    calendarSyncHelp:
      "Zalijepite Airbnb i Booking.com iCal export linkove ovdje. RentPilot će uvesti te kalendare i blokirati odgovarajuće datume.",
    airbnbIcalLink: "Airbnb iCal link",
    bookingIcalLink: "Booking.com iCal link",
    rentPilotExportLink: "RentPilot export link",
    rentPilotExportCalendar: "RentPilot export kalendar",
    rentPilotExportHelp:
      "Kopirajte ovaj link u Airbnb i Booking.com kako bi mogli blokirati datume iz RentPilota.",
    rentPilotExportHelpLong:
      "Zalijepite ovaj link u postavke vanjskog kalendara na Airbnbu ili Booking.com-u.",
    airbnbConnected: "Airbnb povezan",
    airbnbNotConnected: "Airbnb nije povezan",
    bookingConnected: "Booking.com povezan",
    bookingNotConnected: "Booking.com nije povezan",
    noExternalCalendarsConnected: "Nema povezanih vanjskih kalendara.",
    copyShareExportLink: "Kopiraj export link",
    exportLinkMissing:
      "Export link nedostaje. Backend nije vratio calendar_export_url za ovu jedinicu.",
    exportLinkCopied: "Export link je kopiran.",
    editUnit: "Uredi jedinicu",
    saveUnit: "Spremi jedinicu",
    noUnitsDescription:
      "Dodajte sobe/apartmane kako bi se rezervacije i zadaci čišćenja mogli povezati s ovim objektom.",
    activateUnit: "Aktiviraj jedinicu",
    deactivateUnit: "Deaktiviraj jedinicu",
    failedDeleteProperty: "Brisanje objekta nije uspjelo.",
    failedDeleteUnit: "Brisanje jedinice nije uspjelo.",
    failedUpdateUnit: "Ažuriranje jedinice nije uspjelo.",
  },

  statistics: {
    title: "Statistika",
    revenue: "Prihod",
    bookings: "Rezervacije",
    nights: "Noćenja",
    averageBooking: "Prosječna rezervacija",
    breakdown: "Pregled",
    noStatistics: "Nema statistike za odabrane filtere.",
    groupBy: "Grupiraj po",
    unit: "Jedinica",
    property: "Objekt",
    month: "Mjesec",
    payment: "Plaćanje",
    sevenDays: "7 dana",
    fourteenDays: "14 dana",
    thirtyDays: "30 dana",
    thisMonth: "Ovaj mjesec",
    allProperties: "Svi objekti",
    allUnits: "Sve jedinice",
    byUnit: "Po jedinici",
    byProperty: "Po objektu",
    byMonth: "Po mjesecu",
    netProfit: "Neto dobit",
    occupancy: "Popunjenost",
    profitMargin: "Profitna marža",
    expenseRatio: "Omjer troškova",
    revenueByUnit: "Prihod po jedinici",
    revenueByApartment: "Prihod po apartmanu",
    noRevenueForPeriod: "Nema prihoda za odabrani period.",
    noExpensesForPeriod: "Nema troškova za odabrani period.",
    manualVsRecurringExpenses: "Jednokratni i ponavljajući troškovi",
    cashflow: "Tok novca",
    latestNetProfit: "Zadnja neto dobit: {{amount}}",
    performanceBreakdown: "Pregled performansi",
    breakdownMeta: "{{bookings}} rezervacija · {{nights}} noćenja",
    margin: "Marža",
    revenueExpensesHint: "{{revenue}} prihod · {{expenses}} troškovi",
    expenses: "Troškovi",
    expensesByCategory: "Troškovi po kategoriji",
    filters: "Filteri",
  },

  expenses: {
    expenses: "Troškovi",
    newExpense: "Novi trošak",
    editExpense: "Uredi trošak",
    newRecurringExpense: "Novi ponavljajući trošak",
    editRecurringExpense: "Uredi ponavljajući trošak",
    manualExpenses: "Jednokratni troškovi",
    recurringExpenses: "Ponavljajući troškovi",
    totalExpenses: "Ukupni troškovi",
    noExpenses: "Još nema troškova.",
    noRecurringExpenses: "Još nema ponavljajućih troškova.",
    name: "Naziv",
    category: "Kategorija",
    categoryPlaceholder: "Čišćenje, režije, održavanje...",
    amount: "Iznos",
    date: "Datum",
    frequency: "Učestalost",
    monthly: "Mjesečno",
    yearly: "Godišnje",
    interval: "Interval",
    dayOfMonth: "Dan u mjesecu",
    startDate: "Početni datum",
    endDate: "Završni datum",
    active: "Aktivno",
    inactive: "Neaktivno",
    noProperty: "Nema objekta",
    noUnit: "Nema jedinice",
    uncategorized: "Bez kategorije",
    expensesByCategory: "Troškovi po kategoriji",
    expensesByType: "Troškovi po tipu",
    expensesByUnit: "Troškovi po jedinici",
    addExpense: "Dodaj trošak",
    oneTimeExpense: "Jednokratni trošak",
    oneTimeExpenseDescription:
      "Koristi za jedan trošak, npr. popravak, ručnike ili jednu kupovinu.",
    recurringExpense: "Ponavljajući trošak",
    recurringExpenseDescription:
      "Koristi za troškove koji se ponavljaju, npr. internet, pretplate ili mjesečne potrepštine.",
  },

  profile: {
    title: "Profil",
    firstName: "Ime",
    lastName: "Prezime",
    phone: "Telefon",
    saveProfile: "Spremi profil",
    profileUpdated: "Profil ažuriran.",
    updateEmail: "Ažuriraj email",
    currentPassword: "Trenutna lozinka",
    emailUpdated: "Email ažuriran.",
    password: "Lozinka",
    newPassword: "Nova lozinka",
    confirmNewPassword: "Potvrdi novu lozinku",
    updatePassword: "Ažuriraj lozinku",
    passwordUpdated: "Lozinka ažurirana.",
    passwordsDoNotMatch: "Nova lozinka i potvrda se ne podudaraju.",
    language: "Jezik",
    signOutQuestion: "Jeste li sigurni da se želite odjaviti?",
    failedProfileUpdate: "Nije moguće ažurirati profil.",
    failedEmailUpdate: "Nije moguće ažurirati email.",
    failedPasswordUpdate: "Nije moguće ažurirati lozinku.",
    email: "Email",
    emailPlaceholder: "email@example.com",
    phonePlaceholder: "+387...",
    firstNamePlaceholder: "Ime",
    lastNamePlaceholder: "Prezime",
    currentPasswordPlaceholder: "Trenutna lozinka",
    newPasswordPlaceholder: "Nova lozinka",
    confirmNewPasswordPlaceholder: "Potvrdi novu lozinku",
    signOut: "Odjavi se",
    currencySettings: "Valuta",
  },

  currency: {
    currency: "Valuta",
    currencyUpdated: "Valuta ažurirana",
    defaultCurrency: "Zadana valuta",
    bam: "KM",
    eur: "€",
    usd: "$",
    rsd: "RSD",
    failedCurrencyUpdate: "Valuta nije ažurirana.",
  },

  support: {
    title: "Podrška",
    needSupport: "Trebate podršku?",
    description:
      "Kontaktirajte nas ako trebate pomoć s računom, rezervacijama, objektima, timom ili pretplatom.",
    callSupport: "Nazovi podršku",
    emailSupport: "Pošalji email podršci",
  },

  subscription: {
    title: "Pretplata",
    subtitle: "Odaberite paket koji odgovara vašem smještaju.",
    currentPlan: "Trenutni paket",
    freeNotice: "Trenutno koristite besplatni paket.",
    perMonth: "/ mjesečno",
    choosePlan: "Odaberi paket",
    manageBilling: "Upravljaj naplatom",
    upgradeRequired: "Potrebna nadogradnja",
    upgradeRequiredMessage:
      "Dosegnut je limit vašeg trenutnog paketa. Nadogradite pretplatu.",
    accessWarningTitle: "Pristup RentPilotu uskoro istječe",

    accessWarningMessage:
      "Vaš pristup RentPilotu istječe {{date}}. Odaberite ili obnovite paket prije tog datuma kako biste nastavili unositi i mijenjati podatke.",

    customAccessWarningMessage:
      "Vaš prilagođeni RentPilot paket istječe {{date}}. Kontaktirajte RentPilot podršku i dogovorite plaćanje prije tog datuma kako biste nastavili koristiti aplikaciju.",

    accessExpiredTitle: "Pristup RentPilotu je ograničen",

    accessExpiredMessage:
      "Vaša pretplata je istekla ili nije plaćena. I dalje možete pregledavati postojeće podatke, ali unos i izmjene su onemogućeni dok uplata ne bude evidentirana.",

    customAccessExpiredMessage:
      "Vaš prilagođeni RentPilot paket je istekao ili nije plaćen. I dalje možete pregledavati postojeće podatke, ali unos i izmjene su onemogućeni. Kontaktirajte RentPilot podršku kako biste dogovorili plaćanje i ponovno aktivirali pristup.",

    contactAccountOwnerMessage:
      "Kontaktirajte vlasnika računa kako bi dogovorio plaćanje i ponovno aktivirao puni pristup.",

    viewPlansCta: "Pregledaj pakete",

    contactSupportCta: "Kontaktiraj podršku",

    noticeCloseCta: "Razumijem",
    billingPeriod: "Period naplate",
    trialExpiresSoonBanner:
      "Vaš probni period ističe za {{hours}} sati. Da nastavite koristiti RentPilot, odaberite paket u web aplikaciji.",
    trialExpiresSoonCta: "Odaberi paket",
    billingPeriodDescription:
      "Odaberite koliko mjeseci želite platiti unaprijed.",
    planColumn: "Paket",
    limitColumn: "Limit",
    priceColumn: "Cijena",
    discountColumn: "Popust",
    featuresColumn: "Uključeno",
    actionColumn: "Akcija",
    recommended: "Preporučeno",
    discountBadge: "{{discount}}% popusta",
  },

  menu: {
    pricing: "Cijene",
    pricingDescription: "Pregled trenutnog paketa i opcija naplate.",
    currentPlan: "Trenutni paket",
    pricingComingSoon: "Upravljanje cijenama bit će povezano ovdje.",
    myAccount: "Moj račun",
    myAccountDescription: "Profil, email i lozinka.",
    support: "Podrška",
    supportDescription: "Kontaktirajte podršku ili pogledajte informacije.",
    settings: "Postavke",
    settingsDescription: "Izgled aplikacije, jezik i valuta",
    privacy: "Privatnost i podaci o trgovcu",
    privacyDescription:
      "Podaci o tvrtki, korisničkoj službi i zaštiti privatnosti.",
  },

  settings: {
    appAppearance: "Izgled aplikacije",
    fontSize: "Veličina fonta",
    fontSmall: "Malo",
    fontMedium: "Srednje",
    fontLarge: "Veliko",
    fontVeryLarge: "Vrlo veliko",
    bookingColors: "Boje rezervacija",
    theme: "Tema",
    themeSystem: "Sustav",
    themeLight: "Svijetla",
    themeDark: "Tamna",
  },

  roles: {
    role: "Uloga",
    owner: "Vlasnik",
    manager: "Menadžer",
    cleaner: "Sobarica",
    viewer: "Promatrač",
    teamMember: "Član tima",
  },

  invoices: {
    title: "Poslani računi",
    description: "Pregled poslanih računa i povijesti slanja.",
    emptyTitle: "Još nema računa",
    empty: "Još nije poslan nijedan račun.",
    failedLoad: "Nije moguće učitati račune.",
    sentAt: "Poslano",
    status: {
      pending: "Na čekanju",
      sent: "Poslano",
      failed: "Neuspješno",
    },
  },
  accountDeletion: {
    title: "Brisanje računa",
    description:
      "Ovim šaljete zahtjev za trajno brisanje računa. Svi objekti, jedinice, rezervacije, gosti, članovi tima, fakture, zadaci čišćenja, troškovi i postavke povezane s ovim računom bit će obrisani.",
    warning:
      "Brisanje se zakazuje sa sigurnosnim odgodom, ali ovo koristite samo ako ste sigurni.",
    typeDelete: "Upišite DELETE za potvrdu brisanja računa.",
    requestDeletion: "Zatraži brisanje",
    alreadyScheduled: "Brisanje računa je već zakazano za {{date}}.",
    cancelInfo:
      "Zahtjev za brisanje možete otkazati prije zakazanog datuma brisanja.",
    cancelDeletion: "Otkaži zahtjev za brisanje",
    cancelQuestion: "Da li ste sigurni da želite otkazati zahtjev za brisanje?",
    scheduledMessage: "Brisanje računa je zakazano.",
    cancelledMessage: "Zahtjev za brisanje računa je otkazan.",
    failedRequest: "Nije moguće zatražiti brisanje računa.",
    failedCancel: "Nije moguće otkazati brisanje računa.",
  },

  merchant: {
    title: "Podaci o trgovcu",
    description:
      "Osnovni podaci o pravnom subjektu koji pruža i naplaćuje uslugu RentPilot.",
    legalName: "Puni naziv pravnog subjekta",
    address: "Adresa",
    businessActivity: "Djelatnost",
    activityCode: "Šifra djelatnosti",
    registrationNumber: "Matični broj",
    taxNumber: "Porezni / JIB broj",
    website: "Web adresa",
    phone: "Kontakt telefon",
    email: "Kontakt e-mail",

    customerServiceTitle: "Korisnička služba",
    customerServiceDescription:
      "Za informacije o narudžbama i plaćanju, reklamacije, otkazivanje usluge i druge upite možete nas kontaktirati putem navedenih podataka.",

    privacyTitle: "Zaštita privatnosti",
    privacyDescription:
      "RentPilot prikuplja samo podatke potrebne za pružanje usluge, upravljanje korisničkim računom, obradu narudžbi i plaćanja, korisničku podršku i ispunjavanje zakonskih obveza. Osobni podaci se ne prodaju. Podaci su dostupni samo ovlaštenim osobama i pružateljima usluga kojima su potrebni za izvršavanje njihovih obveza. Podaci o kartici unose se isključivo na zaštićenoj stranici procesora plaćanja i nisu dostupni niti se pohranjuju u sustavu RentPilot.",
  },
};
